import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function ImpactOutcomes() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/impact/stats").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const outcomes = data?.program_outcomes || [];

  return (
    <section
      id="impact"
      data-testid="impact-outcomes-section"
      className="py-20 md:py-28 bg-brand-sand"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-coral mb-4">
            What your support delivers
          </div>
          <h2 className="font-display font-black text-4xl md:text-5xl leading-[1.05] tracking-tight text-brand-navy">
            Real structure.{" "}
            <span className="text-slate-400">Real outcomes. Every week.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {outcomes.map((o, i) => (
            <motion.div
              key={i}
              data-testid={`outcome-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-white rounded-3xl p-6 md:p-8 border border-slate-200 hover:shadow-xl transition-shadow"
            >
              <div className="font-display font-black text-5xl md:text-6xl text-brand-navy leading-none">
                {o.value}
              </div>
              <div className="mt-4 font-semibold text-brand-navy">{o.label}</div>
              <div className="mt-1 text-sm text-slate-500">{o.sub}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
